import { AxiosResponse } from "axios"
import { IEntityGST, IGenericResponseGST } from "services/core/genericEntityGST"
import { RequestGST } from "services/Instances"

export const DocumentosServices = () => {
  const path = 'itensAnexados'

  const getByFilter = async (params: IConsultaDocumentosGetByFilterParams): Promise<AxiosResponse<IDocumentosGetByFilterResponse>> =>
    await RequestGST.get(path, { params })

  return {
    getByFilter
  }
}

export const CentrosServices = () => {
  const path = 'CentroPlanta'

  const getCentroByEmpresaId = async (empresaId: number): Promise<AxiosResponse<ICentroPlantas>> =>
    await RequestGST.get(`${path}/FindByEmpresaId/${empresaId}`)

  const getAllCentroPlantas = async (): Promise<AxiosResponse<IEntityGST<IGetAllCentroPlantasResponse>>> =>
    await RequestGST.get(`${path}/PopularGrids`)

  return {
    getAllCentroPlantas,
    getCentroByEmpresaId
  }
}

export interface IConsultaDocumentosGetByFilterParams {
  empresaId?: number,
  centroPlantaId?: number,
  documentoStatus?: number,
  cdContrato?: string,
  nmFornecedor?: string,
  itemSegurancaId?: number,
  dtRetornoInicial?: string | Date,
  dtRetornoFinal?: string | Date,
  dtAnexadoInicial?: string | Date,
  dtAnexadoFinal?: string | Date,
  enviarListas?: boolean,
  pageNumber?: number,
  pageSize?: number,
}
export interface IDocumentosGetByFilterResponse extends IGenericResponseGST {
  entity: IitensAnexadosEntity
}

export interface IitensAnexadosEntity {
  documentoStatus: IDocumentosStatus[],
  empresas: IEmpresas[],
  itensSeguranca: IitensAnexados[],
  paginatedItens?: IConsultaDocumentosItens<Iitems[]>
}

export interface IConsultaDocumentosItens<T> {
  firstItemOnPage: number,
  hasNextPage: boolean,
  hasPreviousPage: boolean,
  isFirstPage: boolean,
  lastItemOnPage: number,
  pageCount: number,
  pageNumber: number,
  pageSize: number,
  totalItemCount: number,
  items: T
}

export interface Iitems {
  cdContrato: string
  documentoStatus: string
  statusDescricao: string
  comAnexo: boolean
  dtAnexo: string
  dtRetorno: string
  idCentroPlanta: number
  idContrato: number
  idContratoExternal: number
  idEmpresa: number
  idFornecedor: number
  idItemAnexado: number
  idItemSegContrato: number
  idItemSeguranca: number
  nmCentro: string
  nmEmpresa: string
  nmFornecedor: string
  nmItemSeguranca: string
  gedExternalId: number
}

export interface IDocumentosStatus {
  codigoDeStatus: number,
  descricao: string
}

export interface IEmpresas {
  empresaId: number,
  nmEmpresa: string
}

export interface IitensAnexados {
  dsItemSeguranca: string
  flSubItem: boolean
  idItemSeguranca: number
  nmItemSeguranca: string
  txLegislacaoItemSeguranca: string
}

export interface ICentroPlantas extends IGenericResponseGST {
  entity: ICentroPlantasItens[]
}
export interface ICentroPlantasItens {
  idCentroPlanta: number,
  txDescricaoCentroPlanta: string
}
export interface IGetAllCentroPlantasResponse {
  comValidacao: IGenericGetAllCentro[];
  semValidacao: IGenericGetAllCentro[];
}
export interface IGenericGetAllCentro {
  idCentroPlanta: number;
  empresaId: number;
  txDescricaoCentroPlanta: string;
  cdCentroCusto: string;
  cdCep: string;
  cdUF: string;
  nuCNAE: string;
  nuCNPJ: string;
  nuTelefone: string;
  txCidade: string;
  txEndereco: string;
  dtUltimaAtualizaçãoSap: string;
  dtAtualizaçãoSap: string;
  flNecessitaValidacao: boolean;
}
